import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { RequestHelper } from '../../Lib/Helper/RequestHelper';
import { AxProgressBar, Step } from "../../Limestone/AxProgressBar/AxProgressBar";
import { ProgressBar, ProgressBarMode } from "../Global/Progressbar";
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { AxAlertBanner as AxAlertBanner } from "../../Limestone/AxMessage/AxAlertBanner";
import { I18nHelper, Translations } from '../../Lib/Helper/I18nHelper';


@ModuleName("Reserved")
export class Reserved implements AxInit {
    private InitData: ReservedInitData;

    public ProjectNr: number;
    public PosNr: number;
    public SerialNr: number;

    protected btnSubmit = document.getElementById('goNext') as HTMLButtonElement;
    protected AlertBanner: AxAlertBanner = new AxAlertBanner();

    constructor(private _Progressbar = new ProgressBar(),
        private _AxProgressBar = new AxProgressBar,
        protected _RequestHelper = new RequestHelper(),
        private _i18nHelper = new I18nHelper) { }

    AxInit(init: ReservedInitData): void {
        let that = this;
        this.InitData = init;
        let count: number = 0;

        //let alertAdditionalClasses = "ax-alert-banner--success";

        if (this.InitData.Message != null && this.InitData.Message.length > 0) {
            this.AlertBanner.ShowMessage('alert_ax', this.InitData.Message, JSON.parse(this.InitData.MessageType.toString().toLowerCase()));
        }

        this.AlertBanner.ShowWarningMessage('reserveAdvanceAlert', this.InitData.ReserveInAdvanceMessage, 'las la-info-circle');

        let sts: Step[] = this._Progressbar.GetReservationSteps();


        $(document).on("click", "a.delete_me", function (e) {
            that.DeleteTimeSlot(e.currentTarget);
        });

        this.btnSubmit.disabled = true;

        for (let step of sts) {
            if (count != -1) {
                if (count < this.InitData.Progress) {
                    step.type = 'done';
                } else if (count == this.InitData.Progress) {
                    step.type = 'active';
                } else if (count > this.InitData.Progress) {
                    step.type = 'inactive';
                }
            }
            count++;
        }

        this._AxProgressBar.Init({
            target: ".reservation__progressbar",
            steps: sts
        });
    }

    DeleteTimeSlot(e: Element): void {
        let that = this;
        let element: JQuery<Element> = $(e);
        let date: string = element.attr('data-date');

        let real_date = new Date(date);

        Swal.fire({
            title: this._i18nHelper.GetTranslation(Translations.AreYouSure),
            text: this._i18nHelper.GetTranslation(Translations.DeleteReservationPopup) + ' ' + real_date.toLocaleDateString(),

            showCancelButton: true,

            confirmButtonText: this._i18nHelper.GetTranslation(Translations.DeleteConfirmationPopup)
        } as SweetAlertOptions).then((result) => {
            if (result.value) {
                AxessViewer.loadPartialView('/Reservations/RemoveReservation', { projNr: this.InitData.ProjNr, posNr: this.InitData.PosNr, serialNr: this.InitData.SerialNr, date: date }, function (resp) {

                    if (resp.success) {
                        that.AlertBanner.ShowMessage('alert_ax', resp.message, true);
                        that.ReloadSlots();
                    }
                    else {
                        that.AlertBanner.ShowMessage('alert_ax', resp.message, false);
                    }

                }, { silent: true });
            }
        });
    }

    ReloadSlots(): void {

        AxessViewer.loadPartialView('/Reservations/_ReloadReservations', {
            ticket: { ProjNr: this.InitData.ProjNr, PosNr: this.InitData.PosNr, SerialNr: this.InitData.SerialNr }
        }, (resp) => {
            $('#slots_counter').html(resp.view);
        }, {});
    }


}


export interface ReservedInitData {
    ProgressBarMode: ProgressBarMode;
    Progress: number;
    ProjNr: number;
    PosNr: number;
    SerialNr: number;
    MessageType: string;
    Message: string;
    ReserveInAdvanceMessage: string;
}
